import React from 'react';
import moment from 'moment';

class TimeAgoComponent extends React.Component {
  render() {
    const { date } = this.props;
    const currentTime = moment();
    const messageTime = moment(date);
    const diffInSeconds = currentTime.diff(messageTime, 'seconds');
    const diffInMinutes = currentTime.diff(messageTime, 'minutes');
    const diffInHours = currentTime.diff(messageTime, 'hours');
    const diffInDays = currentTime.diff(messageTime, 'days');
    const diffInWeeks = currentTime.diff(messageTime, 'weeks');
    const diffInMonths = currentTime.diff(messageTime, 'months');

    let formattedTimeAgo = '';

    if (diffInSeconds < 60) {
      formattedTimeAgo = 'now';
    } else if (diffInMinutes < 60) {
      formattedTimeAgo = `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
    } else if (diffInHours < 24) {
      formattedTimeAgo = `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
    } else if (diffInDays < 7) {
      formattedTimeAgo = `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
    } else if (diffInWeeks < 4) {
      formattedTimeAgo = `${diffInWeeks} week${diffInWeeks !== 1 ? 's' : ''} ago`;
    } else if (diffInMonths < 12) {
      formattedTimeAgo = `${diffInMonths} month${diffInMonths !== 1 ? 's' : ''} ago`;
    } else {
      formattedTimeAgo = `${Math.floor(diffInMonths / 12)} year${Math.floor(diffInMonths / 12) !== 1 ? 's' : ''} ago`;
    }

    return (
      <div>
        <p className='time'>{formattedTimeAgo}</p>
      </div>
    );
  }
}

export default TimeAgoComponent;
